import * as React from "react";
import { connectSearchBox } from "react-instantsearch-dom";
import { SearchBoxProvided } from "react-instantsearch-core";
import { InputForm } from "@silversea-ssc/ui-components-react";

export interface SearchBarProps extends Partial<SearchBoxProvided> {
  placeholder: string;
}

const SearchBar: React.FC<SearchBarProps> = ({
  currentRefinement,
  refine,
  placeholder
}) => (
  <InputForm
    name="query"
    placeholder={placeholder}
    inputType="search"
    icon="search"
    buttonVariant="transparent"
    value={currentRefinement}
    onChange={(event) => refine && refine(event.currentTarget.value)}
    dataContentPiece="search_bar_interaction"
  />
);

export default connectSearchBox<SearchBarProps>(SearchBar);
